"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shallowEqualityCheck = void 0;
const react_1 = require("react");
const useRefFn_1 = __importDefault(require("./useRefFn"));
const isUpdaterFn = (value) => typeof value === 'function';
const inc = (i) => i + 1;
const defaultEqualityCheck = (a, b) => a === b;
const shallowEqualityCheck = (a, b) => {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    return (aKeys.length === bKeys.length && aKeys.every((key) => a[key] === b[key]));
};
exports.shallowEqualityCheck = shallowEqualityCheck;
const useSyncState = (initialValue, onUpdate, equalityCheck = defaultEqualityCheck) => {
    const value = (0, useRefFn_1.default)(initialValue);
    const [_, forceUpdate] = (0, react_1.useState)(0);
    return [
        value.current,
        (0, react_1.useCallback)((valueOrUpdater, force = false, silent = false) => {
            // @ts-ignore
            const nextValue = isUpdaterFn(valueOrUpdater)
                ? valueOrUpdater(value.current)
                : valueOrUpdater;
            if (!force && equalityCheck(value.current, nextValue)) {
                return;
            }
            value.current = nextValue;
            if (!silent && onUpdate) {
                onUpdate(value.current);
            }
            forceUpdate(inc);
        }, [onUpdate]),
    ];
};
exports.default = useSyncState;
